import { useEffect, useState } from "react";
import toast from "react-hot-toast";
import { useList } from "react-use";
import { SearchInput } from "../../components/Input";
import Layout from "../../components/Layout";
import { ModalSwitch } from "../../components/Modal";
import api, { catchApiErrorMessage } from "../../services/api";
import { OrganizationType } from "../../types/OrganizationTypes";
import GenerateReportModal from "../Organization/modals/GenerateReportModal";

function Reports()
{
    const [organizations, {set: setOrganizations}] = useList<OrganizationType>()
    const [searchQuery, setSearchQuery] = useState<string>('')

    const filteredOrganizations = organizations.filter(o => searchQuery.length ? o.name.toLowerCase().includes(searchQuery.toLocaleLowerCase()) : true)

    useEffect(() => {
        api.get('/organizations')
        .then(({data}) => setOrganizations(data))
        .catch(e => toast.error(catchApiErrorMessage(e)))
    }, [setOrganizations])

    return <Layout title="Relatórios">
        {organizations == null ? <>Carregando...</> : <>
            <div className="flex justify-between items-center">
                <h1 className="text-lg font-semibold m-0">Gerar Relatórios ({organizations.length} empresa{organizations.length !== 1 ? 's' : ''})</h1>
                <SearchInput onChange={(event) => setSearchQuery(event.target.value)} />
            </div>
            <table className="w-full mt-4">
                <thead>
                    <tr>
                        <th></th>
                        <th>ID</th>
                        <th>Nome da Empresa</th>
                        <th>Documentos</th>
                        <th>Ação</th>
                    </tr>
                </thead>
                <tbody>
                    {filteredOrganizations.map(organization => <tr key={organization.id}>
                        <td></td>
                        <th>{organization.id}</th>
                        <td>{organization.name}</td>
                        <td>{organization.totalDocuments?.toLocaleString() || '0'}</td>
                        <td>
                            <ModalSwitch
                                modal={GenerateReportModal}
                                modalProps={{organizationId: organization.id}}
                                button={(props: any) => <button {...props} className="bg-blue-500 hover:bg-blue-600 text-white text-sm rounded py-2 px-4">Gerar relatório</button>}
                            />
                        </td>
                    </tr>)}
                </tbody>
            </table>
        </>}
    </Layout>
}

export default Reports;